module.exports = __webpack_public_path__ + "components/media-kit/static/skin-desktop-101c502e0700d619f05fd1a7e41cd1f9.png";